import React, { useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import MainSection from "../../components/mainLayout/Main";
import { DatePicker } from "antd";
import { createEvent } from "../../redux/actions/authActions";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";

function CreateEvent() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    date: "",
    description: ""
  });

  const onChange = (date, dateString) => {
    setFormData({ ...formData, date: dateString });
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    if (id === "name" || id === "description") {
      // Allow only letters and spaces
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [id]: lettersOnly });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.name.length > 20) {
      return message.error("Event title too long. Must be 20 characters or less.");
    }

    if (!formData.date) {
      return message.error("Please select a valid date.");
    }

    try {
      await dispatch(createEvent(formData));
      navigate("/Calendar");
    } catch (err) {
      console.error(err);
      message.error("Failed to create event.");
    }
  };

  return (
    <div>
      <Sidebar />
      <MainSection>
        <SectionHeader title="Add Event" />

        <div className="container w-full md:w-1/2 lg:w-1/3 text-start">
          <form onSubmit={handleSubmit}>

            {/* Event Title */}
            <div className="my-5">
              <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
                Event Title
              </label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="Enter Title"
                required
              />
            </div>

            {/* Event Date */}
            <div className="mb-5">
              <label className="block mb-2 text-sm font-medium text-gray-900">
                Event Date
              </label>
              <DatePicker
                className="w-full p-2.5 rounded-lg border border-gray-300 text-sm"
                onChange={onChange}
                disabledDate={(current) =>
                  current && current < new Date().setHours(0, 0, 0, 0)
                }
              />
            </div>

            {/* Event Description */}
            <div className="my-5">
              <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">
                Description
              </label>
              <textarea
                id="description"
                value={formData.description}
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                placeholder="Enter Description"
                required
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Create
            </button>
          </form>
        </div>
      </MainSection>
    </div>
  );
}

export default CreateEvent;
